<form [formGroup]="formGroup">
  <p>This marks the document as successfully screened.<br>
    This means that it has passed Title/Abstract Screening
    or/and Full-Text Screening.</p>

  <section class="section">
    <mat-checkbox class="checkbox" formControlName="passedOne">Accept Title/Abstract screening manually</mat-checkbox>
    <mat-checkbox class="checkbox" formControlName="passedTwo">Accept Full-Text screening manually</mat-checkbox>
  </section>

  <mat-form-field class="full-width">

    <mat-label>Reason</mat-label>
    <textarea matInput formControlName="reason" placeholder="Enter a reason"
              [required]="formGroup.get('passed')?.value ?? false"></textarea>
    @if (formGroup.get('passed')?.value) {
      <mat-hint> Please provide a reason</mat-hint>
    }
    @if (formGroup.get('passed')?.hasError('required')) {
      <mat-error>Reason is required</mat-error>
    }
  </mat-form-field>

  @if (editable()) {
    <app-save-btn [element]="process()" (clicked)="save(formGroup)"></app-save-btn>
  }
</form>




